<template>
    <div class="alert" id="login">
        <div class="container_basic middle">
            <!-- 扫码登录 -->
            <template v-if="login_config">
                <header class="top">
                    <span class="header_tit">二维码登录</span>
                </header>
                <div class="cont">
                    <vue-qr :logoSrc="img" :text="url" :size="224" :margin="0" :dotScale = '1'></vue-qr>
                    <span class="code_info">请打开马拉松报名手机APP<br>赛事 > 扫一扫</span>
                    <span class="bot_info">没有账号？ <span @click="openRegister">注册</span></span>
                </div>
            </template>    
            <!-- 账号登录 -->
            <template v-else>
                <header class="top2">
                    <span class="header_tit2">{{tit}}</span>
                </header>
                <div class="cont2">
                    <input type="text" class="tel_num" v-model="phoneNum" placeholder="请输入手机号">
                    <input type="password" class="pwd_num" v-model="pwdNum" placeholder="请输入密码">
                    <div class="cont2_bot clearfix">
                        <span class="error f_left" v-show="isError"><span class="error_icon"></span>{{isError}}！</span>
                        <span class="forget f_right">
                            忘记了？
                            <span @click="openReset">找回密码</span>
                        </span>
                    </div>
                    <button class="login" @click.enter="login_submit">登录</button>
                    <!-- <span class="warn_txt">继续表示您同意<span @click.stop="goXieyi">马拉松用户协议</span></span> -->
                    <div class="noLogin clearfix">
                        <div class="f_left">
                            <button class="check f_left" v-if="isChecked" @click="chooseNologin"></button>
                            <button class="check check_act f_left" v-else @click="chooseNologin">✔</button>
                            <span class="f_left">十天免登录</span>
                        </div>
                        <span class="forget f_right">
                            没有账号？
                            <span @click="openRegister">注册</span>
                        </span>
                    </div>
                </div>
            </template>
            <span class="code_img" v-if="login_config" @click="changeLogin"></span>
            <span class="code_img code_img2" v-else @click="changeLogin"></span>
            <div class="close_icon" @click="closeAlert"></div>
        </div>
        
    </div>
</template>

<script>
import {checkPhone} from '../../config/utils'
import {basic} from '../../config/request'
import vueQr from 'vue-qr'
export default {
    name:'Login',
    components:{
        vueQr
    },
    inject:['reload'],
    props: {
        login_config:{
            type:Boolean
        },
        url:{
            type:String
        },
    },
    watch: {
        login_config(newval,oldval) {
            this.login_config = newval;
        },
        url(newval,oldval) {
            this.url = newval;
        }
    },
    data() {
        return {
            tit:'账号登录',//顶部标题
            img:require('../../assets/public//favicon.png'),
            phoneNum:'',//手机号
            pwdNum:'',//密码
            isChecked:true,//默认不选择十天免登陆
            isError:'',//错误信息
        }
    },
    methods: {
        //是否选择是免登录
        chooseNologin() {
            this.isChecked = !this.isChecked;
        },
        // 切换登录方式
        changeLogin() {
            this.$emit('changeLogin',!this.login_config)
        },
        closeAlert() {
            this.isError = "";
            this.phoneNum = "";
            this.pwdNum = "";
            this.$emit('closeLogin',false)
        },
        //打开注册弹框
        openRegister() {
            this.$emit('openRegister',true)
        },
        // 打开重置密码
        openReset() {
            this.$emit('openReset',true)
        },
        // 点击登录
        login_submit() {
            // 是否选择十天免登陆
            let mdr = this.isChecked ? 2 : 1;
            if(this.phoneNum == "" && this.pwdNum != "") {
                this.isError = "账号不能为空";
            }else if(this.phoneNum != "" && this.pwdNum == "") {
                this.isError = "密码不能为空";
            }else if(this.phoneNum == "" && this.pwdNum == "") {
                this.isError = "账号和密码不能为空";
            }else {
                let password = this.encryptString(this.pwdNum);
                basic.log({
                    phone:this.phoneNum,
                    password:password,
                    mdr:mdr,
                    base:1
                }).then(res => {
                    if(res.code==1) {
                        // 获取token并存储
                        let access_token = res.data.tokenInfo.access_token;
                        sessionStorage.setItem('access_token',access_token);
                        // 获取用户信息
                        this.$emit('setInfo',res.data.user)
                        this.reload();
                        this.isError = "";
                        this.closeAlert();
                    }else if(res.code==400){
                        this.isError = "账号或密码输入错误，请重新修改";
                    }else if(res.code==401){
                        this.isError = "用户不存在";
                    }
                })
            } 
        },
        // 查看协议
        goXieyi() {
             this.$router.push({
                path:'/xieyi',
            })
        }
    },
    mounted() {
        this.isError="";
    }
}
</script>

<style scoped>
@import '../../assets/alertPublic/public.css';
@import './style/login.css';
</style>
